import StatusIndicator from "../../common/status-indicator/index.js";
import TableLink from "../../common/table/table-link/index.js";
import TableOptionsCell from "../../common/table/table-options-cell/index.js";
import Tags from "../../common/tags/index.js";

const FormatCurrency = (value) => {
  console.log(value.value, "value>>>");
  const [whole, decimal] = value.value
    .toLocaleString("en-US", { minimumFractionDigits: 2 })
    .split(".");
  return (
    <>
      ${whole}
      {/* <Text variant="smallText" color="lightText">
          .{decimal}
        </Text> */}
    </>
  );
};

const formatLastDirectOrderDate = (value) => {
  if (!value) return "No orders";
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return "No orders";
  return date.toLocaleDateString("en-US", {
    month: "2-digit",
    day: "2-digit",
    year: "numeric",
  });
};

export const dummyTableHeaders = [
  {
    field: "number",
    headerName: "PO Number",
    // headerComponent: CustomHeader,
    filter: true,
    cellRenderer: (params) => <TableLink value={params.data.number} />,
  },
  {
    field: "orderDate",
    filter: true,
    headerName: "Order Date",
    // headerComponent: CustomHeader,
    minWidth: 160,
  },
  {
    field: "account",
    filter: true,
    // headerComponent: CustomHeader,
    cellRenderer: (params) => <TableLink value={params.data.account} />,
  },
  {
    field: "distributor",
    filter: true,
    headerName: "Distributor",
    // headerComponent: CustomHeader,
    cellRenderer: (params) => <TableLink value={params.data.distributor} />,
  },
  {
    field: "Total",
    filter: true,
    // headerComponent: CustomHeader,
    cellRenderer: (params) => <FormatCurrency value={params.data.total} />,
    minWidth: 130,
  },
  {
    field: "status",
    filter: true,
    cellRenderer: StatusIndicator,
    // headerComponent: CustomHeader,
  },
  {
    field: "Options",
    headerName: "Options",
    cellRenderer: TableOptionsCell,
    // headerComponent: CustomHeader,
    minWidth: 280,
  },
  {
    field: "",
    headerName: "",
    // headerComponent: CustomHeader,
    // cellRenderer: OptionsButton,
    minWidth: 80,
  },
];

export const invoices = [
  {
    number: "PO04032025HGTUIP#3(3)",
    orderDate: "April 4, 2025",
    account: "Apex Wound Care",
    distributor: "JEH Medical LLC",
    total: 168,
    status: "Past Due",
    statusType: "failure",
    optionOne: "Add Tracking",
    optionOneType: "primary",
    optionOneClick: <></>,
    optionOne: "Add Invoice",
    optionOneType: "primary",
    optionOneClick: <></>,
  },
  {
    number: "PO04032025HGTUIP#3(3)",
    orderDate: "April 4, 2025",
    account: "Apex Wound Care",
    distributor: "JEH Medical LLC",
    total: 13068,
    status: "Open Balance",
    statusType: "warning",
    optionOne: "Add Tracking",
    optionOneType: "primary",
    optionOneClick: <></>,
    optionOne: "Add Invoice",
    optionOneType: "primary",
    optionOneClick: <></>,
  },
  {
    number: "PO04032025HGTUIP#3(3)",
    orderDate: "April 5, 2025",
    account: "Apex Wound Care - Pittsburgh Pennsylvania",
    distributor: "JEH Medical LLC",
    total: 13098,
    status: "Fully Paid",
    statusType: "success",
    optionOne: "Track",
    optionOneType: "success",
    optionOneClick: <></>,
    optionOne: "View Invoice",
    optionOneType: "warning",
    optionOneClick: <></>,
  },
  {
    number: "PO04032025HGTUIP#3(3)",
    orderDate: "April 4, 2025",
    account: "Apex Wound Care",
    distributor: "JEH Medical LLC",
    total: 1268,
    status: "Open Balance",
    statusType: "complete",
    optionOne: "Track",
    optionOneType: "success",
    optionOneClick: <></>,
    optionOne: "Delete",
    optionOneType: "failure",
    optionOneClick: <></>,
  },
  {
    number: "PO04032025HGTUIP#3(3)",
    orderDate: "April 4, 2025",
    account: "Apex Wound Care",
    distributor: "JEH Medical LLC",
    total: 13068,
    status: "Open Balance",
    statusType: "complete",
    optionOne: "Track",
    optionOneType: "success",
    optionOneClick: <></>,
    optionOne: "Delete",
    optionOneType: "failure",
    optionOneClick: <></>,
  },
  {
    number: "PO04032025HGTUIP#3(3)",
    orderDate: "May 4, 2025",
    account: "Apex Wound Care",
    distributor: "JEH Medical LLC",
    total: 1068,
    status: "Open Balance",
    statusType: "complete",
    optionOne: "Track",
    optionOneType: "success",
    optionOneClick: <></>,
    optionOne: "Delete",
    optionOneType: "failure",
    optionOneClick: <></>,
  },
  {
    number: "PO04032025HGTUIP#3(3)",
    orderDate: "April 4, 2025",
    account: "Apex Wound Care",
    distributor: "JEH Medical LLC",
    total: 13068,
    status: "Open Balance",
    statusType: "complete",
    optionOne: "Track",
    optionOneType: "success",
    optionOneClick: <></>,
    optionOne: "Delete",
    optionOneType: "failure",
    optionOneClick: <></>,
  },
  {
    number: "PO04032025HGTUIP#3(3)",
    orderDate: "December 4, 2025",
    account: "Apex Wound Care",
    distributor: "JEH Medical LLC",
    total: 13068,
    status: "Open Balance",
    statusType: "complete",
    optionOne: "Track",
    optionOneType: "success",
    optionOneClick: <></>,
    optionOne: "Delete",
    optionOneType: "failure",
    optionOneClick: <></>,
  },
];

export const approvalsInvoices = [
  {
    ID: "123",
    OrderDate: "2024-01-01",
    PONumber: "PO456",
    AccountID: "A-789",
    AccountName: "Test Account",
    ManufacturerName: "TestManu",
    ManufacturerID: "M-001",
    OrderType: "Standard",
    OrderTotal: "1000",
  },
  {
    ID: "123",
    OrderDate: "2024-01-01",
    PONumber: "PO456",
    AccountID: "A-789",
    AccountName: "Test Account",
    ManufacturerName: "TestManu",
    ManufacturerID: "M-001",
    OrderType: "Standard",
    OrderTotal: "1000",
  },
  {
    ID: "123",
    OrderDate: "2024-01-01",
    PONumber: "PO456",
    AccountID: "A-789",
    AccountName: "Test Account",
    ManufacturerName: "TestManu",
    ManufacturerID: "M-001",
    OrderType: "Standard",
    OrderTotal: "1000",
  },
];

export const breadcrumbsItems = [
  { label: "All Accounts", link: "/" },
  { label: "WoundCare Clinic", link: "/" },
  { label: "Invoice #68769", link: "/" },
];

export const timeframeButtons = ["YTD", "MTD"];

export const listItems1 = [
  {
    DistributorName: "Primary Content",
    // secondaryName: "Secondary Content Content",
    // number: "$12,345",
    percent: "12.3%",
  },
  {
    DistributorName: "Primary Content",
    // secondaryName: "Secondary Content Content",
    // number: "$12,345",
    percent: "12.3%",
  },
  {
    DistributorName: "Primary Content",
    // secondaryName: "Secondary Content Content",
    // number: "$12,345",
    percent: "12.3%",
  },
];

// export const tableHeadersApprovals = [
//   {
//     headerName: "ID",
//     field: "ID",
//   },

//   {
//     headerName: "Order Date",
//     field: "OrderDate",
//   },
//   {
//     headerName: "PO Number",
//     field: "PONumber",
//     isSearchable: true,
//   },
//   {
//     headerName: "Account ID",
//     field: "AccountID",
//   },
//   {
//     headerName: "Account",
//     field: "AccountName",
//   },
//   {
//     headerName: "Manufacturer",
//     field: "ManufacturerName",
//   },
//   {
//     headerName: "ManufacturerID",
//     field: "ManufacturerID",
//   },
//   {
//     headerName: "Order Type",
//     field: "OrderType",
//   },
//   {
//     headerName: "Order Total",
//     field: "OrderTotal",
//   },
//   {
//     headerName: "Action",
//     field: "",
//     // isFormatter: true,
//     // formatterType: "modalButtonApprovalsDashboard",
//   },
// ];

// export const tableHeadersAccounts = [
//   {
//     headerName: "Account Name",
//     field: "AccountName",
//     filter: true,
//     cellRenderer: (params) => (
//       <TableLink
//         value={params.data.AccountName}
//         path={`/Account/${params.data.ID}`}
//       />
//     ),
//   },

//   {
//     headerName: "Distributor",
//     field: "DistributorName",
//     filter: true,
//     cellRenderer: (params) => (
//       <TableLink
//         value={params.data.DistributorName}
//         path={`/Distributor/${params.data.DistributorID}`}
//       />
//     ),
//   },
//   {
//     headerName: "Region",
//     field: "RegionName",
//     filter: true,
//     isSearchable: true,
//   },
//   {
//     headerName: "Orders YTD",
//     field: "OrdersYTD",
//     filter: true,
//     cellDataType: "number",
//   },
//   {
//     headerName: "Sales YTD",
//     field: "SalesYTD",
//     filter: true,
//     cellDataType: "number",
//     valueGetter: (params) =>
//       parseFloat(String(params.data.SalesYTD).replace(/[^0-9.-]+/g, "")),
//     cellRenderer: (params) => {
//       const value = parseFloat(
//         String(params.data.SalesYTD).replace(/[^0-9.-]+/g, "")
//       );
//       return `$${value.toLocaleString()}`;
//     },
//   },
//   {
//     headerName: "Open Balance",
//     field: "OpenBalance",
//     filter: true,
//     cellDataType: "number",
//     valueGetter: (params) =>
//       parseFloat(String(params.data.OpenBalance).replace(/[^0-9.-]+/g, "")),
//     cellRenderer: (params) => {
//       const value = parseFloat(
//         String(params.data.OpenBalance).replace(/[^0-9.-]+/g, "")
//       );
//       return `$${value.toLocaleString()}`;
//     },
//   },
//   {
//     headerName: "Past Due",
//     field: "OpenBalancePastDueDate",
//     filter: true,
//     cellDataType: "number",
//     valueGetter: (params) =>
//       parseFloat(
//         String(params.data.OpenBalancePastDueDate).replace(/[^0-9.-]+/g, "")
//       ),
//     cellRenderer: (params) => {
//       const value = parseFloat(
//         String(params.data.OpenBalancePastDueDate).replace(/[^0-9.-]+/g, "")
//       );
//       return `$${value.toLocaleString()}`;
//     },
//   },
//   {
//     headerName: "Action",
//     field: "",
//     sortable: false,
//     cellRenderer: (params) => (
//       <TableOptionsCell
//         optionOne="View"
//         optionOneType="warning"
//         optionOneClickPath={`/Account/${params.data.ID}`}
//         rowData={params.data}
//       />
//     ),
//   },
// ];

// export const tableHeadersInvoices = [
//   {
//     headerName: "Invoice Number",
//     field: "InvoiceNumber",
//     filter: true,
//     cellRenderer: (params) => (
//       <TableLink
//         value={params.data.InvoiceNumber}
//         path={`/InvoiceHome/${params.data.ID}`}
//       />
//     ),
//   },
//   {
//     headerName: "PO Number",
//     field: "PONumber",
//     filter: true,
//     cellRenderer: (params) => <TableLink value={params.data.PONumber} />,
//   },
//   {
//     headerName: "Invoice Date",
//     field: "InvoiceDate",
//     filter: true,
//     isSearchable: true,
//   },
//   {
//     headerName: "Due Date",
//     field: "InvoiceDueDate",
//     filter: true,
//   },
//   {
//     headerName: "Account Name",
//     field: "AccountName",
//     filter: true,
//   },
//   {
//     headerName: "Manufacturer Name",
//     field: "ManufacturerName",
//     filter: true,
//   },
//   {
//     headerName: "Past Due",
//     field: "OpenBalancePastDueDate",
//     filter: true,
//   },
//   {
//     headerName: "Total",
//     field: "InvoiceTotal",
//     filter: true,
//     cellDataType: "number",
//     valueGetter: (params) =>
//       parseFloat(String(params.data.InvoiceTotal).replace(/[^0-9.-]+/g, "")),
//     cellRenderer: (params) => {
//       const value = parseFloat(
//         String(params.data.InvoiceTotal).replace(/[^0-9.-]+/g, "")
//       );
//       return `$${value.toLocaleString()}`;
//     },
//   },
//   {
//     headerName: "Action",
//     field: "",
//     cellRenderer: (params) => (
//       <TableOptionsCell
//         optionOne="View"
//         optionOneType="warning"
//         optionOneClickPath={`/InvoiceHome/${params.data.ID}`}
//         rowData={params.data}
//       />
//     ),
//   },
// ];

// export const tableHeadersDistributorSalesRep = [
//   {
//     headerName: "Name",
//     field: "FirstName",
//     cellRenderer: (params) => (
//       <TableLink
//         value={params.data.FirstName + " " + params.data.LastName}
//         path={`/DistributorUserDetails/${params.data.ID}`}
//       />
//     ),
//   },
//   {
//     headerName: "Phone",
//     field: "Phone",
//   },
//   {
//     headerName: "Email",
//     field: "Email",
//   },
//   {
//     headerName: "Role",
//     field: "Role",
//   },
// ];

// export const tableHeadersAccountHomeInvoiceTable = [
//   {
//     headerName: "Invoice",
//     field: "InvoiceNumber",
//     filter: true,
//     cellRenderer: (params) => (
//       <TableLink
//         value={params.data.InvoiceNumber}
//         path={`/InvoiceHome/${params.data.ID}`}
//       />
//     ),
//   },
//   {
//     headerName: "Invoice Date",
//     field: "InvoiceDate",
//     filter: true,
//   },
//   {
//     headerName: "Due Date",
//     field: "InvoiceDueDate",
//     filter: true,
//   },
//   {
//     headerName: "Due In",
//     field: "DueIn",
//     filter: true,
//   },
//   {
//     headerName: "Account Name",
//     field: "AccountName",
//     filter: true,
//     cellRenderer: (params) => (
//       <TableLink
//         value={params.data.AccountName}
//         path={`/Account/${params.data.AccountID}`}
//       />
//     ),
//   },
//   {
//     headerName: "Manufacturer",
//     field: "ManufacturerName",
//     filter: true,
//     cellRenderer: (params) => (
//       <TableLink
//         value={params.data.ManufacturerName}
//         path={`/Manufacturer/${params.data.ManufacturerID}`}
//       />
//     ),
//   },
//   {
//     headerName: "Total",
//     field: "InvoiceTotal",
//     filter: true,
//     cellDataType: "number",
//     valueGetter: (params) =>
//       parseFloat(String(params.data.InvoiceTotal).replace(/[^0-9.-]+/g, "")),
//     cellRenderer: (params) => {
//       const value = parseFloat(
//         String(params.data.InvoiceTotal).replace(/[^0-9.-]+/g, "")
//       );
//       return `$${value.toLocaleString()}`;
//     },
//   },
//   {
//     headerName: "Open Balance",
//     field: "OpenBalance",
//     filter: true,
//     cellDataType: "number",
//     valueGetter: (params) =>
//       parseFloat(String(params.data.OpenBalance).replace(/[^0-9.-]+/g, "")),
//     cellRenderer: (params) => {
//       const value = parseFloat(
//         String(params.data.OpenBalance).replace(/[^0-9.-]+/g, "")
//       );
//       return `$${value.toLocaleString()}`;
//     },
//   },
//   {
//     headerName: "Action",
//     field: "",
//     sortable: false,
//     cellRenderer: (params) => (
//       <TableOptionsCell
//         optionOne="View"
//         optionOneType="warning"
//         optionOneClickPath={`/InvoiceHome/${params.data.ID}`}
//         rowData={params.data}
//       />
//     ),
//   },
// ];

export const tableHeadersAccountProductPricing = [
  {
    headerName: "Manufacturer",
    field: "ManufacturerName",
    filter: true,
    cellRenderer: (params) => (
      <TableLink
        value={params.data.ManufacturerName}
        path={`/Manufacturer/${params.data.ManufacturerID}`}
      />
    ),
  },
  {
    headerName: "Product Name",
    field: "ProductName",
    filter: true,
  },
  {
    headerName: "Product Code",
    field: "ProductCode",
    filter: true,
  },
  {
    headerName: "Price for this Account",
    field: "Price",
    filter: true,
  },
  {
    headerName: "Availability",
    field: "",
    cellRenderer: (params) => <StatusIndicator params={params} />,
  },
  {
    headerName: "Action",
    field: "",
  },
];

// export const tableHeadersAccountUsers = [
//   {
//     headerName: "Name",
//     field: "FirstName",
//     filter: true,
//     cellRenderer: (params) => (
//       <TableLink
//         value={params.data.FirstName + " " + params.data.LastName}
//         path={`/AccountUserDetails/${params.data.ID}`}
//       />
//     ),
//   },
//   {
//     headerName: "Role",
//     field: "RoleType",
//     filter: true,
//   },
//   {
//     headerName: "Email",
//     field: "Email",
//     filter: true,
//   },
//   {
//     headerName: "Phone",
//     field: "Phone",
//     filter: true,
//   },
//   {
//     headerName: "Notes",
//     field: "",
//     filter: true,
//   },
//   {
//     headerName: "Action",
//     field: "",
//   },
// ];

// export const tableHeadersChildAccounts = [
//   {
//     headerName: "Account Name",
//     field: "AccountName",
//     filter: true,
//   },
//   {
//     headerName: "Action",
//     field: "",
//     cellRenderer: (params) => (
//       <TableOptionsCell
//         optionOne="View"
//         optionOneType="warning"
//         optionOneClickPath={`/Account/${params.data.ID}`}
//       />
//     ),
//   },
// ];

export const tableHeadersDistributorDashboard = [
  {
    headerName: "Distributor",
    field: "DistributorName",
    filter: true,
    cellRenderer: (params) => (
      <TableLink
        value={params.data.DistributorName}
        path={`/Distributor/${params.data.ID}`}
      />
    ),
  },
  {
    headerName: "Status",
    field: "",
    filter: true,
    cellRenderer: (params) => (
      <div
        style={{ display: "inline-flex", alignItems: "center", height: "100%" }}
      >
        <Tags
          textColor={
            params.data.IsActive === true
              ? "successColorDark"
              : "failureColorDark"
          }
          tagBackground={
            params.data.IsActive === true
              ? "successColorLight"
              : "failureColorLight"
          }
          tagText={params.data.IsActive === true ? "Active" : "Inactive"}
        />
      </div>
    ),
  },
  {
    headerName: "Accounts",
    field: "Accounts",
    filter: true,
    cellRenderer: (params) => <div>{params.data.Accounts.length}</div>,
  },
  {
    headerName: "Sales YTD",
    field: "SalesYTD",
    filter: true,
    cellDataType: "number",
    valueGetter: (params) =>
      parseFloat(String(params.data.SalesYTD).replace(/[^0-9.-]+/g, "")),
    cellRenderer: (params) => {
      const value = parseFloat(
        String(params.data.SalesYTD).replace(/[^0-9.-]+/g, "")
      );
      return `$${value.toLocaleString()}`;
    },
  },
  {
    headerName: "Active YTD",
    field: "",
    filter: true,
    cellDataType: "number",
    valueGetter: (params) =>
      parseFloat(String(params.data.SalesYTD).replace(/[^0-9.-]+/g, "")),
    cellRenderer: (params) => {
      const value = parseFloat(
        String(params.data.SalesYTD).replace(/[^0-9.-]+/g, "")
      );
      return `$${value.toLocaleString()}`;
    },
  },
  {
    headerName: "Sales MTD",
    field: "SalesMTD",
    filter: true,
    cellDataType: "number",
    valueGetter: (params) =>
      parseFloat(String(params.data.SalesMTD).replace(/[^0-9.-]+/g, "")),
    cellRenderer: (params) => {
      const value = parseFloat(
        String(params.data.SalesMTD).replace(/[^0-9.-]+/g, "")
      );
      return `$${value.toLocaleString()}`;
    },
  },
  {
    headerName: "Active MTD",
    field: "",
    filter: true,
    cellDataType: "number",
    valueGetter: (params) =>
      parseFloat(String(params.data.SalesMTD).replace(/[^0-9.-]+/g, "")),
    cellRenderer: (params) => {
      const value = parseFloat(
        String(params.data.SalesMTD).replace(/[^0-9.-]+/g, "")
      );
      return `$${value.toLocaleString()}`;
    },
  },
  {
    headerName: "Days Since Last Order",
    field: "DaysSinceLastDirectOrder",
    filter: true,
    cellDataType: "number",
    valueGetter: (params) =>
      params.data?.DaysSinceLastDirectOrder === null ||
      params.data?.DaysSinceLastDirectOrder === undefined
        ? -1
        : Number(params.data.DaysSinceLastDirectOrder),
    cellRenderer: (params) => {
      const days = params.data?.DaysSinceLastDirectOrder;
      const hasOrder = days !== null && days !== undefined;
      return (
        <div style={{ lineHeight: "18px" }}>
          <div>{hasOrder ? days : "-"}</div>
          <div style={{ color: "#6b7280", fontSize: "12px" }}>
            {formatLastDirectOrderDate(params.data?.LastDirectOrderDate)}
          </div>
        </div>
      );
    },
  },
  // {
  //   headerName: "Action",
  //   field: "",
  //   cellRenderer: (params) => (
  //     <TableOptionsCell
  //       optionOne="View"
  //       optionOneType="warning"
  //       optionOneClickPath={`/Distributor/${params.data.ID}`}
  //     />
  //   ),
  // },
];
